import React, { useContext, useEffect, useRef, useState } from "react";
import optionarrow from "../../Assets/Images/optionarrow.svg";
import { Button } from "@mui/material";
import Overview from "./Reports/report-pdf/Overview";
import Snapshot from "./Reports/report-pdf/Snapshot";
import StarterQuadrant from "../../Components/AssessmentDetail/Reports/report-pdf/StarterQuardrant";
import QuadrantFlow from "./Reports/report-pdf/QuadrantFlow";
import LeadershipStyle from "./Reports/report-pdf/LeadershipStyle";
import Mindset from "./Reports/report-pdf/Mindset";
import Item from "./Reports/report-pdf/Item";
import FourQuadrants from "./Reports/report-pdf/FourQuadrants";
import HeartStarterQuadrants from "./Reports/report-pdf/HeartStarterQuadrants";
import Heart from "./Reports/report-pdf/Heart";
import Soul from "./Reports/report-pdf/Soul";
import Mind from "./Reports/report-pdf/Mind";
import Strength from "./Reports/report-pdf/Strength";
import YourQuardrantsFlow from "./Reports/report-pdf/YourQuardrantsFlow";
import HeartToSoul from "./Reports/report-pdf/HeartToSoul";
import QFItemOnePage from "./Reports/report-pdf/QF_ItemOnePage";
import QFItemTwoPage from "./Reports/report-pdf/QF_ItemTwoPage";
import LeadershipStyle2 from "./Reports/report-pdf/LeadershipStyle2";
import LeadershipStyle3 from "./Reports/report-pdf/LeadershipStyle3";
import LeadershipStyle4 from "./Reports/report-pdf/LeadershipFlow2";
import LeadershipFlow from "./Reports/LeadershipFlow";
import LeadershipFlow2 from "./Reports/report-pdf/LeadershipFlow2";
import ItemTwo from "./Reports/report-pdf/ItemTwo";
import CollabrativeInFocus from "./Reports/report-pdf/CollabrativeInFocus";
import VisionaryInFocus from "./Reports/report-pdf/VisionaryInFocus";
import StrategicInFocus from "./Reports/report-pdf/StrategicInFocus";
import PerformanceInFocus from "./Reports/report-pdf/PerformanceInFocus";
import AlignmentFlowFirst from "./Reports/report-pdf/AlignmentFlowFirst";
import AlignmentFlowSecond from "./Reports/report-pdf/AlignmentFlowSecond";
import ReflectAndIntegrate1 from "./Reports/report-pdf/ReflectAndIntegrate1";
import ReflectAndIntegrate2 from "./Reports/report-pdf/ReflectAndIntegrate2";
import ReflectAndIntegrate3 from "./Reports/report-pdf/ReflectAndIntegrate3";
import ReflectAndIntegrate4 from "./Reports/report-pdf/ReflectAndIntegrate4";
import MyDocumentSelf from "../../Pages/GeneratePdf/MyDocumentSelf";
import MyDocument360 from "../../Pages/GeneratePdf/MyDocument360";
import MyDocumentGroup from "../../Pages/GeneratePdf/MyDocumentGroup";
import { CircularProgress } from "@mui/material";
import { pdf } from "@react-pdf/renderer";
import { useSearchParams } from "react-router-dom";
import SelfReportPreview from "./SelfReportPreview";
import ReportPreview360 from "./ReportPreview360";
import GroupReportPreview from "./GroupReportPreview";
import { authenticatedFetch } from "../../utils/apiUtils";
import GroupReportContext from "../../Context/GroupReportContext";
import { useGroupReportDate } from "../../Context/GroupReportDate";
import { generateCombinedPDF, generatePDFById, fetchSelfReportData, fetch360ReportData, fetchVariables } from "../../api";
import AuthContext from "../../Context/AuthContext";
import { toast } from "react-toastify";


const selfMenuItems = [
  { title: "Cover Page", hasCheckbox: false, key: "Cover Page", isActive: false, pageNumber: [1] },
  { title: "Table of Contents", hasCheckbox: false, key: "Table of Contents", isActive: false, pageNumber: [2] },
  { title: "Overview", hasCheckbox: false, key: "Overview", isActive: false, pageNumber: [3, 4, 5] },
  { title: "Snapshot Results", hasCheckbox: true, key: "Snapshot Results", isActive: false, pageNumber: [6] },
  {
    title: "Starter Quadrant", hasCheckbox: true, key: "Starter Quadrant", isActive: false, pageNumber: [7],
    subMenu: [
      { title: "Introduction", hasCheckbox: true, key: "Starter Quadrant Chart", isActive: false, pageNumber: [8] },
      { title: "Results", hasCheckbox: true, key: "Results", isActive: false, pageNumber: [9] },
    ],
  },
  {
    title: "Quadrant Flow", hasCheckbox: true, key: "HomeQuadrantFlow", isActive: false, pageNumber: [10],
    subMenu: [
      { title: "Flow Type", hasCheckbox: true, key: "Introduction", isActive: false, pageNumber: [11] },
      { title: "Results", hasCheckbox: true, key: "Quadrant Flow", isActive: false, pageNumber: [12] },
      {
        title: "Items Overview", hasCheckbox: true, key: "Items Overview Self", isActive: false, pageNumber: [13],
        subMenu: [
          { title: "Items Overview 1", hasCheckbox: true, key: "QFItemOnePage 1", isActive: false, pageNumber: [13] },
          { title: "Items Overview 2", hasCheckbox: true, key: "QFItemTwoPage 2", isActive: false, pageNumber: [14] },
          { title: "Items Overview 3", hasCheckbox: true, key: "QFItemThreePage 3", isActive: false, pageNumber: [15] },
        ],
      },
      {
        title: "Quadrant In Focus", hasCheckbox: true, key: "Quadrant In Focus", isActive: false, pageNumber: [16],
        subMenu: [
          { title: "Heart", hasCheckbox: true, key: "Heart", isActive: false, pageNumber: [16] },
          { title: "Soul", hasCheckbox: true, key: "Soul", isActive: false, pageNumber: [17] },
          { title: "Mind", hasCheckbox: true, key: "Mind", isActive: false, pageNumber: [18] },
          { title: "Strength", hasCheckbox: true, key: "Strength", isActive: false, pageNumber: [19] },
        ],
      },
    ],
  },
  {
    title: "Leadership Style", hasCheckbox: true, key: "Home Leadership Style", isActive: false, pageNumber: [20],
    subMenu: [
      { title: "Introduction", hasCheckbox: true, key: "Leadership Style Introduction", isActive: false, pageNumber: [21] },
      { title: "Results", hasCheckbox: true, key: "Leadership Style Results", isActive: false, pageNumber: [22] },
      { title: "Chart", hasCheckbox: true, key: "Leadership Style Chart", isActive: false, pageNumber: [23] },
    ],
  },
  {
    title: "Leadership Flow", hasCheckbox: true, key: "Leadership Flow Introduction", isActive: false, pageNumber: [24],
    subMenu: [
      { title: "Results", hasCheckbox: true, key: "Leadership Introduction", isActive: false, pageNumber: [24] },
      { title: "Chart", hasCheckbox: true, key: "Leadership Flow Results", isActive: false, pageNumber: [25] },
      {
        title: "Items Overview", hasCheckbox: true, key: "Items Overview Leadership Flow Self", isActive: false, pageNumber: [26],
        subMenu: [
          { title: "Items Overview 1", hasCheckbox: true, key: "Item 1", isActive: false, pageNumber: [26] },
          { title: "Items Overview 2", hasCheckbox: true, key: "Item 2", isActive: false, pageNumber: [27] },
          { title: "Items Overview 3", hasCheckbox: true, key: "Item 3", isActive: false, pageNumber: [28] },
        ],
      },
      {
        title: "Leadership In Focus", hasCheckbox: true, key: "Leadership Style In Focus", isActive: false, pageNumber: [29],
        subMenu: [
          { title: "Collaborative", hasCheckbox: true, key: "Collaborative", isActive: false, pageNumber: [29] },
          { title: "Visionary", hasCheckbox: true, key: "Visionary", isActive: false, pageNumber: [30] },
          { title: "Strategic", hasCheckbox: true, key: "Strategic", isActive: false, pageNumber: [31] },
          { title: "Performance", hasCheckbox: true, key: "Performance", isActive: false, pageNumber: [32] },
        ],
      },
    ],
  },
  {
    title: "Gap Analysis", hasCheckbox: true, key: "Alignment", isActive: false, pageNumber: [33],
    subMenu: [
      { title: "Alignment 1", hasCheckbox: true, key: "Alignment 1", isActive: false, pageNumber: [33] },
      { title: "Alignment 2", hasCheckbox: true, key: "Alignment 2", isActive: false, pageNumber: [34] },
    ],
  },
  {
    title: "Mindset", hasCheckbox: true, key: "Home Mindset", isActive: false, pageNumber: [35],
    subMenu: [
      { title: "Introduction", hasCheckbox: true, key: "Mindset Introduction", isActive: false, pageNumber: [36] },
      { title: "Results", hasCheckbox: true, key: "Mindset Results", isActive: false, pageNumber: [37] },
    ],
  },
  {
    title: "Reflections", hasCheckbox: true, key: "Home Reflect And Integrate", isActive: false, pageNumber: [38],
    subMenu: [
      { title: "Reflect and Integrate", hasCheckbox: true, key: "Reflect and Integrate", isActive: false, pageNumber: [39] },
      { title: "Life Integration", hasCheckbox: true, key: "Life Integration", isActive: false, pageNumber: [40] },
      { title: "Leadership Integration", hasCheckbox: true, key: "Leadership Integration", isActive: false, pageNumber: [41] },
      { title: "Final Thoughts", hasCheckbox: true, key: "Final Thoughts", isActive: false, pageNumber: [42] },
    ],
  },
];

const groupMenuItems = [
  { title: "Cover Page", hasCheckbox: false, key: "Cover Page", isActive: false, pageNumber: [1] },
  { title: "Table of Contents", hasCheckbox: false, key: "Table of Contents", isActive: false, pageNumber: [2] },
  { title: "Snapshot Results", hasCheckbox: true, key: "Summary Snapshot", isActive: false, pageNumber: [3] },
  {
    title: "Starter Quadrant", hasCheckbox: true, key: "Starter Quadrant Results", isActive: false, pageNumber: [4],
    subMenu: [
      { title: "Results", hasCheckbox: true, key: "Starter Quadrant Results", isActive: false, pageNumber: [4] },
      { title: "Chart", hasCheckbox: true, key: "Starter Quadrant Chart", isActive: false, pageNumber: [5] },
    ],
  },
  {
    title: "Quadrant Flow", hasCheckbox: true, key: "Quadrant Flow Results", isActive: false, pageNumber: [6],
    subMenu: [
      { title: "Results", hasCheckbox: true, key: "Quadrant Flow Results", isActive: false, pageNumber: [6] },
      { title: "Flow Type", hasCheckbox: true, key: "Introduction", isActive: false, pageNumber: [7] },
      {
        title: "Items Overview", hasCheckbox: true, key: "Items Overview Group", isActive: false, pageNumber: [8],
        subMenu: [
          { title: "Items Overview 1", hasCheckbox: true, key: "QFItemOnePageGroup", isActive: false, pageNumber: [8] },
          { title: "Items Overview 2", hasCheckbox: true, key: "QFItemTwoPageGroup", isActive: false, pageNumber: [9] },
          { title: "Items Overview 3", hasCheckbox: true, key: "QFItemThreePageGroup", isActive: false, pageNumber: [10] },
        ],
      },
      {
        title: "Quadrant In Focus", hasCheckbox: true, key: "Quadrant In Focus Group", isActive: false, pageNumber: [11],
        subMenu: [
          { title: "Heart", hasCheckbox: true, key: "Heart", isActive: false, pageNumber: [11] },
          { title: "Soul", hasCheckbox: true, key: "Soul", isActive: false, pageNumber: [12] },
          { title: "Mind", hasCheckbox: true, key: "Mind", isActive: false, pageNumber: [13] },
          { title: "Strength", hasCheckbox: true, key: "Strength", isActive: false, pageNumber: [14] },
        ],
      },
    ],
  },
  {
    title: "Leadership Style", hasCheckbox: true, key: "Leadership Style Results", isActive: false, pageNumber: [15],
    subMenu: [
      { title: "Results", hasCheckbox: true, key: "Leadership Style Results", isActive: false, pageNumber: [15] },
      { title: "Chart", hasCheckbox: true, key: "Leadership Style Chart", isActive: false, pageNumber: [16] },
    ],
  },
  {
    title: "Leadership Flow", hasCheckbox: true, key: "Collaborative to Strategic", isActive: false, pageNumber: [17],
    subMenu: [
      { title: "Results", hasCheckbox: true, key: "Collaborative to Strategic", isActive: false, pageNumber: [17] },
      { title: "Chart", hasCheckbox: true, key: "Flow Introduction Group", isActive: false, pageNumber: [18] },
      {
        title: "Items Overview", hasCheckbox: true, key: "Items Overview Leadership Group", isActive: false, pageNumber: [19],
        subMenu: [
          { title: "Items Overview 1", hasCheckbox: true, key: "ItemGroup 1", isActive: false, pageNumber: [19] },
          { title: "Items Overview 2", hasCheckbox: true, key: "ItemGroup 2", isActive: false, pageNumber: [20] },
          { title: "Items Overview 3", hasCheckbox: true, key: "ItemGroup 3", isActive: false, pageNumber: [21] },
        ],
      },
      {
        title: "Leadership In Focus", hasCheckbox: true, key: "Leadership Style In Focus", isActive: false, pageNumber: [22],
        subMenu: [
          { title: "Collaborative", hasCheckbox: true, key: "Collaborative", isActive: false, pageNumber: [22] },
          { title: "Visionary", hasCheckbox: true, key: "Visionary", isActive: false, pageNumber: [23] },
          { title: "Strategic", hasCheckbox: true, key: "Strategic", isActive: false, pageNumber: [24] },
          { title: "Performance", hasCheckbox: true, key: "Performance", isActive: false, pageNumber: [25] },
        ],
      },
    ],
  },
  { title: "Gap Analysis", hasCheckbox: true, key: "AlignmentGroup 1", isActive: false, pageNumber: [26] },
  { title: "Mindset", hasCheckbox: true, key: "Mindset Results", isActive: false, pageNumber: [27] },
  { title: "Final Thoughts", hasCheckbox: true, key: "Final Thoughts", isActive: false, pageNumber: [28] },
];

const menuItems360 = [
  { title: "Cover Page", hasCheckbox: false, key: "Cover Page", isActive: false, pageNumber: [1] },
  { title: "Table of Contents", hasCheckbox: false, key: "Table of Contents", isActive: false, pageNumber: [2] },
  { title: "Overview", hasCheckbox: false, key: "Overview", isActive: false, pageNumber: [3, 4, 5] },
  { title: "Snapshot Results", hasCheckbox: true, key: "Snapshot Results 360", isActive: false, pageNumber: [6] },
  {
    title: "Starter Quadrant", hasCheckbox: true, key: "Starter Quadrant", isActive: false, pageNumber: [7],
    subMenu: [
      { title: "Introduction", hasCheckbox: true, key: "Four Quadrants", isActive: false, pageNumber: [8] },
      { title: "Results", hasCheckbox: true, key: "Results 360", isActive: false, pageNumber: [9] },
    ],
  },
  {
    title: "Quadrant Flow", hasCheckbox: true, key: "HomeQuadrantFlow", isActive: false, pageNumber: [10],
    subMenu: [
      { title: "Flow Type", hasCheckbox: true, key: "Introduction", isActive: false, pageNumber: [11] },
      { title: "Results", hasCheckbox: true, key: "Quadrant Flow", isActive: false, pageNumber: [12] },
      {
        title: "Items Overview", hasCheckbox: true, key: "Items overview 360", isActive: false, pageNumber: [13],
        subMenu: [
          { title: "Items Overview 1", hasCheckbox: true, key: "QFItemOnePage", isActive: false, pageNumber: [13] },
          { title: "Items Overview 2", hasCheckbox: true, key: "QFItemTwoPage", isActive: false, pageNumber: [14] },
          { title: "Items Overview 3", hasCheckbox: true, key: "QFItemThirdPage", isActive: false, pageNumber: [15] },
          { title: "Items Overview 4", hasCheckbox: true, key: "QFItemFourthPage", isActive: false, pageNumber: [16] },
        ],
      },
      {
        title: "Quadrant In Focus", hasCheckbox: true, key: "Heart In Focus 360", isActive: false, pageNumber: [17],
        subMenu: [
          { title: "Heart", hasCheckbox: true, key: "Heart", isActive: false, pageNumber: [17] },
          { title: "Soul", hasCheckbox: true, key: "Soul", isActive: false, pageNumber: [18] },
          { title: "Mind", hasCheckbox: true, key: "Mind", isActive: false, pageNumber: [19] },
          { title: "Strength", hasCheckbox: true, key: "Strength", isActive: false, pageNumber: [20] },
        ],
      },
    ],
  },
  {
    title: "Leadership Style", hasCheckbox: true, key: "Home Leadership Style", isActive: false, pageNumber: [21],
    subMenu: [
      { title: "Introduction", hasCheckbox: true, key: "Leadership Style Introduction", isActive: false, pageNumber: [22] },
      { title: "Results", hasCheckbox: true, key: "Leadership Style Results", isActive: false, pageNumber: [23] },
      { title: "Chart", hasCheckbox: true, key: "Leadership Style Chart", isActive: false, pageNumber: [24] },
    ],
  },
  {
    title: "Leadership Flow", hasCheckbox: true, key: "Leadership Flow Introduction", isActive: false, pageNumber: [25],
    subMenu: [
      { title: "Results", hasCheckbox: true, key: "Leadership Flow Results", isActive: false, pageNumber: [25] },
      { title: "Chart", hasCheckbox: true, key: "Leadership Flow Introduction 360", isActive: false, pageNumber: [26] },
      {
        title: "Items Overview", hasCheckbox: true, key: "Items Overview Leadership 360", isActive: false, pageNumber: [27],
        subMenu: [
          { title: "Items Overview 1", hasCheckbox: true, key: "Item Overview Leadership 1", isActive: false, pageNumber: [27] },
          { title: "Items Overview 2", hasCheckbox: true, key: "Item Overview Leadership 2", isActive: false, pageNumber: [28] },
          { title: "Items Overview 3", hasCheckbox: true, key: "Item Overview Leadership 3", isActive: false, pageNumber: [29] },
          { title: "Items Overview 4", hasCheckbox: true, key: "Item Overview Leadership 4", isActive: false, pageNumber: [30] },
        ],
      },
      {
        title: "Leadership In Focus", hasCheckbox: true, key: "Leadership Flow In Focus 360", isActive: false, pageNumber: [31],
        subMenu: [
          { title: "Collaborative", hasCheckbox: true, key: "Collaborative", isActive: false, pageNumber: [31] },
          { title: "Visionary", hasCheckbox: true, key: "Visionary", isActive: false, pageNumber: [32] },
          { title: "Strategic", hasCheckbox: true, key: "Strategic", isActive: false, pageNumber: [33] },
          { title: "Performance", hasCheckbox: true, key: "Performance", isActive: false, pageNumber: [34] },
        ],
      },
    ],
  },
  {
    title: "Gap Analysis", hasCheckbox: true, key: "Alignment", isActive: false, pageNumber: [35],
    subMenu: [
      { title: "Alignment 1", hasCheckbox: true, key: "Alignment 1", isActive: false, pageNumber: [35] },
      { title: "Alignment 2", hasCheckbox: true, key: "Alignment 2", isActive: false, pageNumber: [36] },
    ],
  },
  {
    title: "Mindset", hasCheckbox: true, key: "Home Mindset", isActive: false, pageNumber: [37],
    subMenu: [
      { title: "Introduction", hasCheckbox: true, key: "Mindset Introduction", isActive: false, pageNumber: [38] },
      {
        title: "Results", hasCheckbox: true, key: "Mindset Results", isActive: false, pageNumber: [39],
        subMenu: [
          { title: "Results 1", hasCheckbox: true, key: "Result 1", isActive: false, pageNumber: [39] },
          { title: "Results 2", hasCheckbox: true, key: "Result 2", isActive: false, pageNumber: [40] },
        ],
      },
    ],
  },
  {
    title: "Reflections", hasCheckbox: true, key: "Home Reflect And Integrate", isActive: false, pageNumber: [41],
    subMenu: [
      { title: "Reflect and Integrate", hasCheckbox: true, key: "Reflect and Integrate", isActive: false, pageNumber: [42] },
      { title: "Life Integration", hasCheckbox: true, key: "Life Integration", isActive: false, pageNumber: [43] },
      { title: "Leadership Integration", hasCheckbox: true, key: "Leadership Integration", isActive: false, pageNumber: [44] },
      { title: "Final Thoughts", hasCheckbox: true, key: "Final Thoughts", isActive: false, pageNumber: [45] },
    ],
  },
]

export default function AssessmentScores({ reportData, reportType, onBackToReports, resultData, memberResults, isLoadingMemberResults, groupMembers }) {
  const isSelfFrom360 = reportData?.isSelfReport === true;
  const [currentReportType, setCurrentReportType] = useState(
    isSelfFrom360 ? "Self" : (reportType || "Self")
  );

  const [menuItems, setMenuItems] = useState(isSelfFrom360 ? selfMenuItems : (reportType === "360" ? menuItems360 : (reportType === "Group" ? groupMenuItems : selfMenuItems)));


  const groupContext = useContext(GroupReportContext)
  const authCtx = useContext(AuthContext)
  const { leaderchartdata, startChartdata, tablevaluesq, tablevaluels, tablevaluesq2, tablevaluels2, leaderselfchartdata, startChartdataSelfchartdata, mindsetscore, mindsetscoreself } = useGroupReportDate();

  const [isLoading, setIsLoading] = useState(false);
  const [isSwitchingReport, setIsSwitchingReport] = useState(false);
  const [reportOptions, setReportOptions] = useState([]);
  const [selectedOption, setSelectedOption] = useState("");
  // Group reports default to pages 1-2, Self and 360 default to pages 1-5
  const [selectedPages, setSelectedPages] = useState(
    reportType?.toLowerCase() === "group" ? [1, 2] : [1, 2, 3, 4, 5]
  );

  // Use an array to track the open path for nested accordion
  const [openMenuPath, setOpenMenuPath] = useState(["Cover Page"]);
  const [openMenus, setOpenMenus] = useState({});

  // Helper: get the deepest selected menu key
  const selectedMenuKey = openMenuPath[openMenuPath.length - 1];
  const [selectedCheckboxes, setSelectedCheckboxes] = useState({});
  const printRef = useRef(null);
  const [searchParams, setSearchParams] = useSearchParams();
  const [apiData, setApiData] = useState(null);
  const [isClicked, setIsClicked] = useState(false);
  const [processedGroupData, setProcessedGroupData] = useState(null);
  const [allGroupResults, setAllGroupResults] = useState({});
  const id = searchParams.get("assessmentId");

  const selectedMeta =
    resultData?.find(r => `${r.name}}` === selectedOption)
    || resultData?.find(r =>
      r.assessment_hash === searchParams.get("assessmentId") &&
      r.reportType === searchParams.get("reportType")
    );

  const displayName =
    currentReportType?.toLowerCase() === "self"
      ? (selectedMeta?.teamName || selectedMeta?.name || apiData?.fullName || "")
      : (selectedMeta?.teamName || selectedMeta?.name || "");


  useEffect(() => {

    const selectedReport = groupContext?.selectedReport;
    let asmt_hash_360 = resultData?.find((el) => `${el?.id}-${reportType}` == selectedReport?.value)?.self_hash

    if (selectedReport.reportType?.toLowerCase() !== "group") {
      // // console.log("result 1")
      fetch(
        `${process.env.REACT_APP_API_URI}/v3/user/assessment/${selectedReport.self_hash || selectedReport?._originalData?.results?.[0]?.hash}/results`,
        {
          method: "GET",
          mode: "cors",
          headers: { "Content-Type": "application/json" },
        }
      )
        .then((response) => response.json())
        .then((data) => {
          if (data.status === "success") {
            setApiData(data);
            setIsLoading(false)
          }
        })
        .catch((error) => {
          // console.error("Error fetching report data:", error);
          setIsLoading(false)
        });
    }


    if (id && resultData?.length > 0) {
      const reportFromUrl = resultData.find(
        (report) => report.assessment_hash === id && currentReportType === report.reportType
      );

      if (reportFromUrl) {
        setCurrentReportType(reportFromUrl.reportType);
        setIsLoading(true)

        // Update reportOptions to ensure dropdown shows correct label
        const reportOptions = resultData.map((item) => ({
          value: `${item.assessment_hash}-${item.reportType}`,
          label: `${item.name} ${item.reportType}-Assessment`,
          reportType: item.reportType,
        }));
        setReportOptions(reportOptions);

        if (reportFromUrl.reportType?.toLowerCase() !== "group") {
          // // console.log("result 2")
          fetch(
            `${process.env.REACT_APP_API_URI}/v3/user/assessment/${reportFromUrl.reportType == "360" ? selectedReport.self_hash : id}/results`,
            {
              method: "GET",
              mode: "cors",
              headers: { "Content-Type": "application/json" },
            }
          )
            .then((response) => response.json())
            .then((data) => {
              if (data.status === "success") {
                setApiData(data);
                setIsLoading(false)
              }
            })
            .catch((error) => {
              // console.error("Error fetching report data:", error);
              setIsLoading(false)
            });
        }
      }
    }
    // // console.log("asmt_hash id resultData", id, resultData)
  }, [id, resultData, memberResults, groupContext?.selectedReport]);


  // // console.log("reportData",reportData)

  useEffect(() => {
    const assessmentIdParam = searchParams.get("assessmentId");
    const reportTypeParam = searchParams.get("reportType");



    // If we have URL parameters but no selected report, initialize from URL
    if (assessmentIdParam && reportTypeParam && !selectedOption) {
      // Find the report from resultData that matches URL parameters
      const reportFromUrl = resultData?.find(
        (report) => report.assessment_hash === assessmentIdParam && report.reportType === reportTypeParam
      );
      
      setCurrentReportType(reportTypeParam);

      if (reportTypeParam === "Group") {
        // Get all assessment IDs for group report
        const groupReports = localStorage.getItem("groupReports");
        const clientDataFromLocal = localStorage.getItem("clientData");

        const data = groupReports ? JSON.parse(groupReports) : [];
        const reportDataFromLocal = data.filter(
          (item) => item.assessment_hash == assessmentIdParam
        );

        // Check if we have valid report data
        if (!reportDataFromLocal || reportDataFromLocal.length === 0) {
          // // console.log("No report data found for assessment:", assessmentIdParam);
          return;
        }

        // Create array of promises for all API calls

         let fetchPromises = []
        if(reportTypeParam?.toLowerCase() !== "group") {
         fetchPromises = reportDataFromLocal[0]?.assessments?.map((assessmentId) => {
            // // console.log("result 3")
            fetch(
              `${process.env.REACT_APP_API_URI}/v3/user/assessment/${assessmentId}/results`,
              {
                method: "GET",
                mode: "cors",
                headers: { "Content-Type": "application/json" },
              }
            )
              .then((response) => response.json())
              .then((data) => ({ id: assessmentId, data }))
          }) || [];
        }
      

        // Add preview API call for group reports
        const urlParams = new URLSearchParams(window.location.search);
        const clientIdFromUrl = window.location.pathname
          .split("/client/")[1]
          ?.split("?")[0];
        const clientId = clientIdFromUrl || localStorage.getItem("clientId");

        const previewApiCall = authenticatedFetch(
          `${process.env.REACT_APP_API_URI}/v5/organisations/tl/preview/${clientId}`,
          {
            method: "GET",
            mode: "cors",
            headers: { "Content-Type": "application/json" },
          }
        )
          .then((response) => {
            return response.json();
          })
          .then((data) => {
            return { type: "preview", data };
          })
          .catch((error) => {
            return { type: "preview", data: null };
          });

        // Wait for all API calls to complete (including preview API)
        Promise.all([...fetchPromises, previewApiCall])
          .then((results) => {
            // Separate preview data from assessment results
            const previewData = results.find(
              (result) => result.type === "preview"
            );
            const assessmentResults = results.filter(
              (result) => result.type !== "preview"
            );

            // Convert array of results to object with assessment IDs as keys
            const groupResults = assessmentResults.reduce(
              (acc, { id, data }) => {
                if (data.status === "success") {
                  acc[id] = data;
                }
                return acc;
              },
              {}
            );

            setAllGroupResults(groupResults);

            // Save preview data separately
            localStorage.setItem("groupReportPreviewData", JSON.stringify(previewData?.data || {})
            );

            // Update the data for current assessment
            const index = data.findIndex((item) => {
              return item.assessment_hash == assessmentIdParam;
            });
            if (index !== -1) {
              const updatedData = {
                ...data[index],
                data: groupResults,
                results: addVariablesInResultsGroupReport(updatedData),
                clientData: clientDataFromLocal
                  ? JSON.parse(clientDataFromLocal)
                  : null,
                lastUpdated: new Date().toISOString(),
              };
              data[index] = updatedData;
              localStorage.setItem("groupReports", JSON.stringify(data));
              setApiData(JSON.stringify(data));
              setProcessedGroupData(updatedData);
            }
          })
          .catch((error) => {
            // console.error("Error fetching group report data:", error);
          });
      } else {
        // Fetch the report data

      }
    }
  }, [searchParams, selectedOption]);

  // Set up report options based on the reportData passed from Reports component
  useEffect(() => {
    if (resultData?.length > 0) {
      const value = []
      const reportOptions = resultData.map((item) => ({
        value: `${item.assessment_hash}-${item.reportType}`,
        label: `${item.teamName || item.name} ${item.reportType === "360" ? "- 360 Report" : `- ${item.reportType}-Assessment`}`,
        reportType: item.reportType,
      }));

      setReportOptions(reportOptions);

      // If reportData is passed (when clicking "View Report"), prioritize it
      if (reportData && reportData.assessment_hash) {
        // Set the selectedOption to match the dropdown format
        const reportName = reportData.teamName || reportData.name || reportData.reportName?.replace(" Group-Assessment", "") || "Unknown Report";

        setCurrentReportType(reportData.reportType);

        // Update URL parameters to match the selected report
        const searchParams = new URLSearchParams(window.location.search);
        // searchParams.set("tab", "reports");
        // searchParams.set("assessmentId", reportData.assessment_hash);
        // searchParams.set("reportType", reportType);

        // Update the URL without triggering a page reload
        const newUrl = `${window.location.pathname}?${searchParams.toString()}`;
        window.history.replaceState({}, "", newUrl);

        // Handle different report types
        if (reportData.reportType === "Group") {
          // Load group report data
          const groupReports = localStorage.getItem("groupReports");
          const previewData = localStorage.getItem("groupReportPreviewData");

          // First, try to find existing group report data
          let reportDataFromLocal = [];

          if (groupReports) {
            const data = JSON.parse(groupReports);
            reportDataFromLocal = data.filter(
              (item) => item.assessment_hash == reportData.assessment_hash
            );
          }

          // If not found in groupReports, try to find it in preview data
          if (
            (!reportDataFromLocal || reportDataFromLocal.length === 0) &&
            previewData
          ) {
            const preview = JSON.parse(previewData);

            if (preview?.data && Array.isArray(preview.data)) {
              const matchingPreview = preview.data.find((item) => {
                // Try to match by generated hash
                const generatedHash =
                  item.teamname?.toLowerCase().replace(/[^a-z0-9]/g, "") +
                  (item.results?.length || 0);
                return (
                  generatedHash === reportData.assessment_hash ||
                  item.teamname ===
                  reportData.teamName?.replace(" Group-Assessment", "")
                );
              });

              if (matchingPreview) {
                // Create a mock group report structure
                const mockGroupReport = {
                  assessment_hash: reportData.assessment_hash,
                  teamname: matchingPreview.teamname,
                  assessments: [], // Will be populated if we find member data
                  data: {}, // Results will be stored here
                  results: matchingPreview.results,
                };

                reportDataFromLocal = [mockGroupReport];
              }
            }
          }

          // Check if we have valid report data
          if (!reportDataFromLocal || reportDataFromLocal.length === 0) {
            const fallbackGroupData = {
              assessment_hash: reportData.assessment_hash,
              teamname:
                reportData.teamName?.replace(" Group-Assessment", "") ||
                "Unknown Team",
              data: {},
              results: {},
              lastUpdated: new Date().toISOString(),
            }; 

            fallbackGroupData.results = addVariablesInResultsGroupReport(fallbackGroupData);

            setProcessedGroupData(fallbackGroupData);
            setApiData(JSON.stringify([fallbackGroupData]));
            return;
          }

          // If we have assessments to fetch, proceed with API calls
          if (reportDataFromLocal[0]?.assessments?.length > 0) {
            // Create array of promises for all API calls
            const fetchPromises = reportDataFromLocal[0].assessments.map(
              (assessmentId) => {
                // // console.log("result 5")
                fetch(
                  `${process.env.REACT_APP_API_URI}/v3/user/assessment/${assessmentId}/resultspr`,
                  {
                    method: "GET",
                    mode: "cors",
                    headers: { "Content-Type": "application/json" },
                  }
                )
                  .then((response) => response.json())
                  .then((data) => ({ id: assessmentId, data }))
              });

            // Add preview API call for group reports
            const urlParams = new URLSearchParams(window.location.search);
            const clientIdFromUrl = window.location.pathname
              .split("/client/")[1]
              ?.split("?")[0];
            const clientId = clientIdFromUrl || localStorage.getItem("clientId");

            const previewApiCall = authenticatedFetch(
              `${process.env.REACT_APP_API_URI}/v5/organisations/tl/preview/${clientId}`,
              {
                method: "GET",
                mode: "cors",
                headers: { "Content-Type": "application/json" },
              }
            )
              .then((response) => {
                return response.json();
              })
              .then((data) => {
                return { type: "preview", data };
              })
              .catch((error) => {
                return { type: "preview", data: null };
              });

            // Wait for all API calls to complete (including preview API)
            Promise.all([...fetchPromises, previewApiCall])
              .then((results) => {
                // Separate preview data from assessment results
                const previewApiData = results.find(
                  (result) => result.type === "preview"
                );
                const assessmentResults = results.filter(
                  (result) => result.type !== "preview"
                );

                // Convert array of results to object with assessment IDs as keys
                const groupResults = assessmentResults.reduce(
                  (acc, { id, data }) => {
                    if (data.status === "success") {
                      acc[id] = data;
                    }
                    return acc;
                  },
                  {}
                );

                setAllGroupResults(groupResults);

                // Save preview data separately
                localStorage.setItem("groupReportPreviewData", JSON.stringify(previewApiData?.data || {}));

                // Create updated data structure
                const updatedData = {
                  ...reportDataFromLocal[0],
                  data: groupResults,
                  results: addVariablesInResultsGroupReport(updatedData),
                  lastUpdated: new Date().toISOString(),
                  previewData: previewApiData?.data,
                };

                setApiData(JSON.stringify([updatedData]));
                setProcessedGroupData(updatedData);
              })
              .catch((error) => {
                // console.error("Error fetching group report data:", error);
              });
          } else {
            // No assessment IDs, just use the preview data
            const simpleGroupData = {
              ...reportDataFromLocal[0],
              lastUpdated: new Date().toISOString(),
            };

            let simpleGroupDataWithResults = {
              ...simpleGroupData,
              results: addVariablesInResultsGroupReport(simpleGroupData),
            }

            setProcessedGroupData(simpleGroupDataWithResults);
            setApiData(JSON.stringify([simpleGroupData]));
          }
        }
        else if (reportData?.reportType == "Self") {
          // // console.log("reportData ===>", reportData)
          // // console.log("result 6");

          const token = localStorage.getItem("token");
          // // console.log("teamId ===>", reportData?.teamId);

          fetch(
            `${process.env.REACT_APP_API_URI}/v5/organisations/tl/preview/${reportData?.assessment_hash}/variables`,
            {
              method: "GET",
              mode: "cors",
              headers: {
                "Content-Type": "application/json",
                "Authorization": `Bearer ${token}`,
              },
            }
          )
            .then((response) => response.json())
            .then((data) => {
              // // console.log("API Response ===>", data);
              if (data.status === "success") {
                // // console.log("data?.data?.results?.[0] ===>", data?.data?.results?.[0]);
                setApiData(data?.data?.results?.[0]);
              }
            })
            .catch((error) => {
              // console.error("Error fetching report data:", error);
            });
        }


      } else if (
        !selectedOption ||
        !reportOptions.find((opt) => opt.value === selectedOption)
      ) {
        // If no selectedOption or selectedOption doesn't exist in new options, select first
        if (reportOptions.length > 0) {
          // Set selectedOption to match the dropdown format
          const firstReport = resultData[0];
          const reportName = firstReport.teamName || firstReport.name || firstReport.reportName?.replace(" Group-Assessment", "") || "Unknown Report";
          setCurrentReportType(reportOptions[0].reportType);
        }
      }
    }
  }, [reportData, resultData]);

  useEffect(() => {
    if (isSelfFrom360 || currentReportType === "Self") {
      setMenuItems(selfMenuItems);
    } else if (currentReportType === "360") {
      setMenuItems(menuItems360);
    } else if (currentReportType === "Group" || currentReportType === "group") {
      setMenuItems(groupMenuItems);
    } else {
      setMenuItems(selfMenuItems);
    }
  }, [currentReportType, isSelfFrom360]);

  useEffect(() => {
    setSelectedPages(currentReportType?.toLowerCase() === "group" ? [1, 2] : [1, 2, 3, 4, 5]);
    setSelectedCheckboxes({});
  }, [currentReportType]);

  useEffect(() => {
    if (isSelfFrom360 && currentReportType !== "Self") {
      setCurrentReportType("Self");
    } else if (!isSelfFrom360 && reportType && currentReportType !== reportType) {
      setCurrentReportType(reportType);
    }
  }, [reportData, reportType, isSelfFrom360]);

  useEffect(() => {
    groupContext?.setApiData(processedGroupData);
  }, [processedGroupData, apiData]);
  
  useEffect(() => {
    setSelectedOption(`${groupContext?.selectedReport?.teamName} - ${groupContext?.selectedReport?.reportType?.toLowerCase()} - ${groupContext?.selectedReport?._originalData?.teamId}`)
  }, [groupContext?.selectedReport])
  


  const updateMenuItemActivity = (key, isActive) => {
    setMenuItems((prevMenuItems) => {
      const updatedMenuItems = JSON.parse(JSON.stringify(prevMenuItems));

      const updateItemActivity = (items) => {
        for (let i = 0; i < items.length; i++) {
          if (items[i].key === key) {
            items[i].isActive = isActive;
            return true;
          }

          if (items[i].subMenu) {
            if (updateItemActivity(items[i].subMenu)) {
              return true;
            }
          }
        }
        return false;
      };

      updateItemActivity(updatedMenuItems);
      return updatedMenuItems;
    });
  };

  const addVariablesInResultsGroupReport = (groupDataPayload) => {
    const tempProcessedData = groupDataPayload?.results?.map((el) => { return { ...el, variables: groupMembers?.[el?.hash] } })

    return tempProcessedData;
  }

  // Find a menu item recursively in the menu structure
  const findMenuItem = (items, key) => {
    for (const item of items) {
      if (item.key === key) return item;
      if (item.subMenu) {
        const found = findMenuItem(item.subMenu, key);
        if (found) return found;
      }
    }
    return null;
  };

  const handleMenuClick = (key) => {
    const menuItem = findMenuItem(menuItems, key);

    // If the item has a submenu, toggle its open/closed state
    if (menuItem && menuItem.subMenu) {
      const isCurrentlyOpen = openMenus[key];
      
      // If menu is already open, close it
      if (isCurrentlyOpen) {
        setOpenMenus(prevOpenMenus => ({
          ...prevOpenMenus,
          [key]: false
        }));
        return;
      }
      
      // Menu is closed, open it
      setOpenMenus(prevOpenMenus => ({
        ...prevOpenMenus,
        [key]: true
      }));
      
      // Auto-select first child if parent and first child share the same page number
      const firstChild = menuItem.subMenu[0];
      if (firstChild && 
          menuItem.pageNumber && 
          firstChild.pageNumber && 
          menuItem.pageNumber[0] === firstChild.pageNumber[0]) {
        // Set both parent and first child as active initially
        setOpenMenuPath([key, firstChild.key]);
        
        // After 200ms, deselect the parent, keep only the child active
        setTimeout(() => {
          setOpenMenuPath([firstChild.key]);
        }, 200);
        
        return;
      }
    }

    // Set the clicked item as the active page to display its content
    setOpenMenuPath([key]);
  };

  const handleCheckboxChange = (event, path) => {
    const isChecked = event.target.checked;

    const findNodeByPath = (items, targetPath, parentPath = "") => {
      for (const item of items) {
        const currPath = parentPath ? `${parentPath}/${item.key}` : item.key;
        if (currPath === targetPath) return { item, currPath };
        if (item.subMenu) {
          const found = findNodeByPath(item.subMenu, targetPath, currPath);
          if (found) return found;
        }
      }
      return null;
    };

    const res = findNodeByPath(menuItems, path);
    if (!res) return;

    const { item } = res;
    const updatedCheckboxes = { ...selectedCheckboxes };
    const tickFromPath = (node, currPath) => {
      updatedCheckboxes[currPath] = isChecked;
      updateMenuItemActivity(node.key, isChecked);
      if (node.subMenu) {
        node.subMenu.forEach((child) => {
          const childPath = `${currPath}/${child.key}`;
          tickFromPath(child, childPath);
        });
      }
    };

    tickFromPath(item, path);

    // Group reports default to pages 1-2, Self and 360 default to pages 1-5
    const pagesSet = new Set(currentReportType?.toLowerCase() === "group" ? [1, 2] : [1, 2, 3, 4, 5]);
    const walk = (node, currPath) => {
      if (updatedCheckboxes[currPath] && node.pageNumber) {
        // Handle pageNumber as array
        if (Array.isArray(node.pageNumber)) {
          node.pageNumber.forEach(pageNum => {
            if (typeof pageNum === 'number' && !isNaN(pageNum)) {
              pagesSet.add(pageNum);
            }
          });
        } else if (typeof node.pageNumber === 'number' && !isNaN(node.pageNumber)) {
          pagesSet.add(node.pageNumber);
        }
      }
      if (node.subMenu) {
        node.subMenu.forEach((child) =>
          walk(child, `${currPath}/${child.key}`)
        );
      }
    };
    menuItems.forEach((root) => walk(root, root.key));

    setSelectedCheckboxes(updatedCheckboxes);
    setSelectedPages(Array.from(pagesSet).sort((a, b) => a - b));
  };

  const handleReportTypeChange = async (selectedItem) => {
    setIsSwitchingReport(true);
    // setSelectedOption(`${selectedItem.name} - ${selectedItem.reportType?.toLowerCase()} - ${selectedItem?._originalData?.teamId}`);
    
    // Update currentReportType to trigger menu update
    setCurrentReportType(selectedItem.reportType);
    
    // Reset menu-related state when switching report types
    setOpenMenuPath(["Cover Page"]);
    setOpenMenus({});
    setSelectedCheckboxes({});
    setSelectedPages(selectedItem.reportType?.toLowerCase() === "group" ? [1, 2] : [1, 2, 3, 4, 5]);
    
    // const selectedId = event.target.value;
    const selectedId = selectedItem?._originalData?.teamId;
    const teamId = selectedId;

    
    const existingReport = groupContext.previewData?.find((el) => el?.teamId == teamId)
    const selfReportId = existingReport?.type == "group" ? teamId : existingReport?.results?.find((el) => el.designation == "Self-Assessment" || el.designation == "360 Assessment")?.hash

    let fetchedVariables = await fetchVariables(teamId);

    const hashMap = {};
    fetchedVariables?.results?.map((el) => {
      hashMap[el?.hash] = el?.variables;
      return null;
    });

    const results = existingReport?.results?.map((el) => {
      const variables = hashMap?.[el?.hash]
      return {
        ...el,
        variables
      }
    });


    // console.log("results,hashMap,existingReport",results,hashMap,existingReport)
 
    let selectedReport = {
      assessment_hash: teamId,
      id: selfReportId,
      name: existingReport?.teamname,
      teamId: teamId,
      remark: ["Group Members", existingReport?.report?.map(member => member.fullName.trim()).join(", ")],
      results,
      reportName: existingReport?.teamname,
      reportType: existingReport?.type,
      self_hash: selfReportId,
      teamName: existingReport?.teamname,
      teamname: existingReport?.teamname,
      createdDate: existingReport?.createdDate,
      _originalData: existingReport
    }

    groupContext?.setSelectedReport(selectedReport);
    groupContext?.setSelectedReportType(selectedReport?.reportType);
    groupContext?.setGroupMembersHashMap({teamId,hashMap});
    // setSelectedOption(`${selectedReport?.teamName} - ${selectedReport?.reportType}- ${selectedItem?._originalData?.teamId}`)
    
    // Update processedGroupData to ensure GroupReportPreview gets the correct data
    setProcessedGroupData(selectedReport);
    // Give React a tick to flush state updates
    await new Promise(r => setTimeout(r, 0));
    setIsSwitchingReport(false);
  };

  const storedMemberIds = JSON.parse(localStorage.getItem("membersReport") || "[]");

  const downloadPDF = async (payload) => {
    const data = await generateCombinedPDF(payload, authCtx);

    if (data?.status === "success" && data?.url) {
      const urlParts = data.url.split("/");
      const fileName = decodeURIComponent(urlParts[urlParts.length - 1]) || `${payload.reportType}.pdf`;
      triggerFileDownload(data.url, fileName);
      
      // Call PUT API to update preview with report link
      const teamId = groupContext?.selectedReport?.teamId;
      if (teamId) {
        try {
          await fetch(
            `${process.env.REACT_APP_API_URI}/v5/organisations/tl/preview/${teamId}`,
            {
              method: "PUT",
              headers: { 
                "Content-Type": "application/json",
                "Authorization": `Bearer ${localStorage.getItem("token")}`
              },
              body: JSON.stringify({
                reportLink: data.url
              }),
            }
          );
        } catch (error) {
          console.error("Failed to update preview with report link:", error);
        }
      }
    } else {
      throw new Error("PDF generation failed.");
    }
  };

  const triggerFileDownload = (blobUrl, fileName) => {
    const link = document.createElement("a");
    link.href = blobUrl;
    link.download = fileName;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const buildReportDetail = (typeLabel, apiData, authCtx) => {
    const clientData = JSON.parse(localStorage.getItem("clientData") || "{}");
    const fullName = apiData?.fullName?.trim() || groupContext?.selectedReport?.name || groupContext?.selectedReport?.reportName?.replace("Group-Assessment", "").trim() || groupContext?.selectedReport?.label?.trim();

    const safeName = fullName
      ? fullName.replace(/\s+/g, "-").replace(/[^a-zA-Z0-9-_]/g, "").toLowerCase()
      : `anonymous-${Date.now()}`;
    const rawLabel = groupContext?.selectedReport?.reportName;
    // For 360 reports, use format: "MindsetTest - assessment_hash"
    const reportName =
      typeLabel === "360"
        ? (rawLabel ? rawLabel.trim() + ' - 360 Report' : groupContext?.selectedReport?.label?.trim() || `MindsetTest - 360 Report`)
        : typeLabel === "self"
          ? `${safeName}-${typeLabel}-assessment`
          : (rawLabel || groupContext?.selectedReport?.label?.trim());

    const reportDate = groupContext.selectedReport?._originalData?.createdDate
      ? new Date(groupContext.selectedReport?._originalData?.createdDate).toLocaleDateString("en-US", {
        month: "long",
        year: "numeric"
      })
      : undefined;

    return {
      reportName: reportName,
      consultantName: authCtx?.userName,
      companyName: processedGroupData?.clientData?.organizationName || apiData?.clientData?.organizationName || clientData?.company || "Company Name",
      reportDate: reportDate,
      teamDetails: {
        teamName:  apiData?.fullName || processedGroupData?.teamname || processedGroupData?.teamName  || "Team 1",
        teamNo: processedGroupData?.groupid || processedGroupData?.clientData?.groupid || clientData.groupid || "N/A"
      },
      // Add GroupReportDate context data
      groupReportData: {
        leaderchartdata: leaderchartdata,
        startChartdata: startChartdata,
        tablevaluesq: tablevaluesq,
        tablevaluels: tablevaluels,
        tablevaluesq2: tablevaluesq2,
        tablevaluels2: tablevaluels2,
        leaderselfchartdata: leaderselfchartdata,
        startChartdataSelfchartdata: startChartdataSelfchartdata,
        mindsetscore: mindsetscore,
        mindsetscoreself: mindsetscoreself
      }
    };
  };

  const handleDownload = async () => {
    setIsClicked(true);
    setIsLoading(true);

    const toResultsArray = (src) => {
      if (!src) return [];
      if (Array.isArray(src)) return src;
      if (Array.isArray(src.results)) return src.results;
      if (src.results && typeof src.results === "object") return Object.values(src.results);
      if (src.data && Array.isArray(src.data.results)) return src.data.results;
      return [];
    };

    try {
      const type = (currentReportType || "").toLowerCase();

      const [optHash, optType] = (selectedOption || "").split("-");

      const urlHash = searchParams.get("assessmentId");
      const urlType = (searchParams.get("reportType") || "").trim();

      const chosen =
        (resultData || []).find(r => `${r.assessment_hash}-${r.reportType}` === selectedOption) ||
        (resultData || []).find(r => r.assessment_hash === urlHash && r.reportType === urlType) ||
        reportData;

      const base = chosen?._originalData || {};

      let ids = [];
      const baseResults = toResultsArray(base);

      if (type === "self") {
        const selfHash = baseResults?.[0]?.hash;
        if (selfHash) ids.push(selfHash);
      } else {
        ids = baseResults.map(r => r?.hash).filter(Boolean);
      }

      if (!ids.length && type === "360" && memberResults) {
        const fromMembers = Object.values(memberResults).flatMap(m => toResultsArray(m)).map(r => r?.hash);
        ids = fromMembers.filter(Boolean);
      }

      if (!ids.length && type === "group") {
        ids = toResultsArray(processedGroupData).map(r => r?.hash).filter(Boolean);
      }

      ids = Array.from(new Set(ids)).filter(Boolean);
      if (!ids.length) {
        toast.error("No data found to export for the selected report.");
        setIsLoading(false);
        return;
      }

      // Build report name from the dropdown value to avoid stale context
      const parseReportNameFromDropdown = (value, fallbackType) => {
        try {
          if (!value) return null;
          const parts = value.split(" - ");
          // Expected: `${name} - ${type} - ${teamId}`
          const rawName = (parts[0] || "").trim();
          const rawType = (parts[1] || fallbackType || "").trim().toLowerCase();
          const safeName = rawName
            ? rawName.replace(/\s+/g, "-").replace(/[^a-zA-Z0-9-_]/g, "").toLowerCase()
            : `anonymous-${Date.now()}`;
          if (rawType === "360") return `${rawName} - 360 Report`;
          if (rawType === "self") return `${safeName}-self-assessment`;
          if (rawType === "group") return rawName || "group";
          return rawName || `report-${Date.now()}`;
        } catch (_) {
          return null;
        }
      };

      let capturedReportName = parseReportNameFromDropdown(selectedOption, type);

      const payload = {
        ids,
        pages: selectedPages.map(String),
        reportType: type === "360" ? "360 report" : (type === "group" ? "group" : "self-report"),
        reportDetail: !capturedReportName ? buildReportDetail(type, apiData, authCtx) : { ...buildReportDetail(type, apiData, authCtx), reportName: capturedReportName },
      };

      await downloadPDF(payload);
    } catch (err) {
      toast.error("Download failed. Please try again.");
    } finally {
      setIsLoading(false);
    }
  };

  // console.log('leaderchartdata', leaderchartdata)
  // console.log('starterchartdata', startChartdata)

  const renderMenu = (menu, parentPath = "") => {
    const path = parentPath ? `${parentPath}/${menu.key}` : menu.key;
    const isMenuOpen = !!openMenus[menu.key];
    // Check if menu is anywhere in the active path (for auto-selection of parent + child)
    const isActive = openMenuPath.includes(menu.key);

    return (
      <div key={path}>
        <div
          className={`assessment-menu-item ${isActive ? "active" : ""}`}
          onClick={(e) => {
            e.stopPropagation();
            handleMenuClick(menu.key);
          }}
        >
          <div className="assessment-flex-img">
            <p>
              {menu.hasCheckbox ? (
                <input
                  className="checkbox"
                  type="checkbox"
                  checked={selectedCheckboxes[path] || false}
                  onChange={(e) => handleCheckboxChange(e, path)}
                  onClick={(e) => e.stopPropagation()}
                />
              ) : (
                <span className="checkbox-placeholder" />
              )}
              {menu.title}
            </p>
            {menu.subMenu && (
              <img
                className="flex-img"
                src={optionarrow}
                alt=""
                style={{
                  transform: isMenuOpen ? "rotate(0deg)" : "rotate(180deg)",
                  transition: "transform 0.3s ease",
                }}
              />
            )}
          </div>
        </div>
        {menu.subMenu && isMenuOpen && (
          <div className="assessment-submenu">
            {menu.subMenu.map((subMenuItem) => renderMenu(subMenuItem, path))}
          </div>
        )}
      </div>
    );
  };

  const renderContent = () => {
    // Use the deepest selected menu key for content rendering
    const reportContent = currentReportType?.toLowerCase() === "360"
      ? <ReportPreview360 activeMenu={selectedMenuKey} apiData={apiData} menuItems={menuItems} memberResults={memberResults} isLoadingMemberResults={isLoadingMemberResults} />
      : currentReportType?.toLowerCase() === "group"
        ? <GroupReportPreview activeMenu={selectedMenuKey} apiData={apiData} groupData={processedGroupData} menuItems={menuItems} />
        : <SelfReportPreview activeMenu={selectedMenuKey} apiData={apiData} menuItems={menuItems} reportDataName={displayName} previewData={resultData} />;

    return reportContent;
  };

  // Add debugging for component render
  // // console.log("selectedMenuKey, apiData, menuItems, memberResults, isLoadingMemberResults",selectedMenuKey, apiData, menuItems, memberResults, isLoadingMemberResults)
  // // console.log("selectedOption,resultData", selectedOption, resultData)
  return (
    <>
      <div className="assessment-scores">
        {/* Sidebar */}
        <div className="assessment-sidebar">
          <div className="assessment-menu">
            {menuItems.map((menu) => renderMenu(menu, ""))}
          </div>
          <div className="assessment-export-btn" style={{ flexDirection: 'column', alignItems: 'center' }}>
            <div style={{ color: '#394554', fontSize: '14px', fontWeight: '400', whiteSpace: 'nowrap', marginBottom: '8px', fontFamily: 'Lato', marginTop: '10px' }}>Select relevant sections to export</div>
            <Button
              className="cta-export-btn"
              onClick={handleDownload}
              disabled={isLoading || isSwitchingReport}
              style={{ margin: 0 }}
            >
              {isLoading ? (
                <CircularProgress style={{ color: "#fff" }} size={24} />
              ) : isSwitchingReport ? (
                "Loading..."
              ) : (
                "Export PDF"
              )}
            </Button>
          </div>
          {(isLoading || isSwitchingReport) ? 
            <div className="download-info">
              <p style={{ textAlign: 'center', fontSize: '16px', color: '#394554' }}>
                {isSwitchingReport ? "Loading report..." : "Generating your PDF..."}<br />
                <span style={{ fontStyle: 'italic', color: '#394554' }}>This may take a few minutes.</span>
              </p>
            </div>
          : ''  
          }
        </div>

        {/* Main Content */}
        <div className="report-section">
          <div className="select-name">
            <select
              className="inputform capitalize"
              required
              value={selectedOption || ""}
              onChange={(e) => {
                const selectedValue = e.target.value;
                const selectedItem = resultData.find(
                  (item) => `${item.name} - ${item.reportType?.toLowerCase()} - ${item?._originalData?.teamId}` === selectedValue
                );
                if (selectedItem) {
                  handleReportTypeChange(selectedItem);
                }
              }}
            >
              {resultData && resultData.length > 0 ? (
                resultData.map((item, index) => (
                  <option
                    key={index}
                    value={`${item.name} - ${item.reportType?.toLowerCase()} - ${item?._originalData?.teamId}`}
                    className="capitalize"
                  >
                    {`${item.name} - ${item.reportType === "360" ? "360 Report" : item.reportType?.toLowerCase()}`}
                  </option>
                ))
              ) : (
                <option value="">No reports available</option>
              )}
            </select>
          </div>
          <div className="assessment-main-content">
            <div className="section">
              {/* Show loading indicator when member results are being fetched for 360 reports */}
              {currentReportType?.toLowerCase() === "360" &&
                isLoadingMemberResults ? (
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    minHeight: "200px",
                    flexDirection: "column",
                  }}
                >
                  <CircularProgress style={{ color: "#245775" }} size={40} />
                  <p style={{ marginTop: "16px", color: "#666" }}>
                    Loading 360 assessment member results...
                  </p>
                </div>
              ) : (
                <div className="scrollable-report-content">
                  {renderContent()}
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
